import { makeStyles } from '@mui/styles'
import Colors from 'utils/Colors'

const styles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    gap: '4rem',
    width: '100%',
  },

  candidateDetails: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    width: '100%',
    padding: '0 1rem 1rem',
    '& > h2': {
      fontSize: '3rem',
      fontWeight: 500,
    },
    '& > h3': {
      fontSize: '2.25rem',
      fontWeight: 500,
      color: Colors.mediumLightGray,
      margin: '1.75rem 0 0.5rem',
    },
  },
  items: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    width: '100%',
  },

  item: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '1rem',
    padding: '1.25rem 0',
    borderBottom: `1px solid ${Colors.gray}`,
    width: '100%',

    '&:first-child': {
      borderTop: `1px solid ${Colors.gray}`,
    },
  },
  
  label:{
    fontWeight: 600,
    minWidth: '15.75rem',
  },
  
}))

export default styles
